import { render, staticRenderFns } from "./ChannelCreate.vue?vue&type=template&id=6367001e&"
import script from "./ChannelCreate.vue?vue&type=script&lang=js&"
export * from "./ChannelCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports